__turbopack_context__.v({
  "index": "style-module-scss-module__kSC7Uq__index",
  "itemDescription": "style-module-scss-module__kSC7Uq__itemDescription",
  "itemTitle": "style-module-scss-module__kSC7Uq__itemTitle",
  "itemsList": "style-module-scss-module__kSC7Uq__itemsList",
  "listItem": "style-module-scss-module__kSC7Uq__listItem",
  "listWrapper": "style-module-scss-module__kSC7Uq__listWrapper",
  "slide": "style-module-scss-module__kSC7Uq__slide",
  "slideshow": "style-module-scss-module__kSC7Uq__slideshow",
  "title": "style-module-scss-module__kSC7Uq__title",
  "wrapper": "style-module-scss-module__kSC7Uq__wrapper",
});
